import { useEffect, useState } from 'react'
import { Select } from 'antd'
import service from '../../@services'
import { connect } from 'react-redux'

const SupplierSelect = ({
  suppliers,
  value,
  style = {},
  onChange,
  allowClear = true,
  OnOptionsLoad
}) => {
  const [$loading, set$loading] = useState(false)
  useEffect(() => {
    // if (!suppliers) {
      set$loading(true)
      service.common
        .getValidSupplierList()
        .then(options => {
          OnOptionsLoad && OnOptionsLoad(options)
          set$loading(false)
        })
        .catch(() => {
          set$loading(false)
        })
    // } else {
    //   OnOptionsLoad && OnOptionsLoad(suppliers)
    // }
  }, [])
  return (
    <Select
      style={{ textAlign: 'left', width: '200px', ...style }}
      onChange={onChange}
      filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
      placeholder='请选择供应商'
      value={value}
      showSearch
      allowClear={allowClear}
      loading={$loading}>
      {suppliers &&
        suppliers.map(item => (
          <Select.Option key={item.supplierId} value={item.supplierId}>
            {item.supplierName}
          </Select.Option>
        ))}
    </Select>
  )
}
export default connect(state => ({ suppliers: state.common.suppliers }))(
  SupplierSelect
)
